// extracted by mini-css-extract-plugin
module.exports = {"page":"page__1PM4C","content":"content__CU50v"};